// extracted by mini-css-extract-plugin
module.exports = {"detailsSection":"DetailsSection_detailsSection__1mHuo"};